import SliderTestimonials from "../modules/slider-testimonials"

new SliderTestimonials()